module.exports = __webpack_public_path__ + "img/fikakopp.05f51280.png";